import { NgModule } from '@angular/core';
import { TooltipActionListComponent } from './tooltip-action-list.component';
import { CommonModule } from '@angular/common';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    SvgIconModule
  ],
  declarations: [
    TooltipActionListComponent
  ],
  exports: [
    TooltipActionListComponent
  ]
})
export class TooltipActionListModule {}
